import '.z{width:100%;}.ssr-plugin'
import '.e5{border-radius:0.75rem;}.ssr-plugin'
import '.en{border:1px solid var(--shades-blue-300);}.ssr-plugin'
import '.eo{padding:0.5rem 1rem;}.ssr-plugin'
import '.e1{font-size:1.125rem;}.ssr-plugin'
import '.d4{line-height:1.75rem;}.ssr-plugin'
import '.ep{resize:vertical;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { forwardRef } from 'react'

export type MultiLineTextInputProps = {
  value: string
  placeholder?: string
  minHeight?: string
  style?: Style
  setValue: (value: string) => void
}

export const MultiLineTextInput = forwardRef<
  HTMLTextAreaElement,
  MultiLineTextInputProps
>(
  (
    {
      value,
      placeholder,
      minHeight = '6.5rem',
      style,
      setValue,
    }: MultiLineTextInputProps,
    ref,
  ) => {
    return (
      <styled.textarea className="z e5 en eo e1 d4 ep"
        ref={ref}
        style={{
          minHeight: minHeight,
          '&:focus': {
            outline: 'none',
            border: '1px solid var(--primary-blue)',
          },
          ...style,
        }}
        placeholder={placeholder}
        value={value}
        onChange={(e) => setValue(e.target.value)}
      ></styled.textarea>
    )
  },
)
